import { render, staticRenderFns } from "./refund-voucher.vue?vue&type=template&id=04b45a1e&scoped=true&"
import script from "./refund-voucher.vue?vue&type=script&lang=js&"
export * from "./refund-voucher.vue?vue&type=script&lang=js&"
import style0 from "./refund-voucher.vue?vue&type=style&index=0&id=04b45a1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b45a1e",
  null
  
)

export default component.exports